var version = '6.2.2';

module.exports = version;
